import { Link } from '@tanstack/react-router';
import { brandOriginUrl } from '@/api';
import { casinoCategoryPath, casinoVendorLogoUrl, type CasinoVendor } from '@/domain';
import { cn } from '@/lib/cn';
import { HorizontalScrollRow } from '@/ui/common';

export interface ProvidersStripProps {
  vendors: CasinoVendor[];
  category?: string;
  className?: string;
}

export function ProvidersStrip({ vendors, category = 'slots', className }: ProvidersStripProps) {
  if (vendors.length === 0) return null;

  return (
    <section className={cn('flex flex-col gap-3', className)} aria-label="Providers">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-heading-s text-text-primary">Providers</h2>
        <Link to="/casino/providers" className="text-label-s text-action-primary hover:underline">
          See all
        </Link>
      </div>
      <HorizontalScrollRow
        aria-label="Providers"
        withDesktopArrows
        className="-mx-1 gap-3 px-1 pb-1 pl-0"
      >
        {vendors.map((vendor) => (
          <div key={vendor.Id} role="listitem">
            <Link
              to={casinoCategoryPath(category, vendor.Name)}
              className="flex h-14 w-28 shrink-0 items-center justify-center rounded-md border border-border-default bg-bg-surface px-3"
              title={vendor.Name}
            >
              <img
                src={casinoVendorLogoUrl(brandOriginUrl(), vendor.Name)}
                alt={vendor.Name}
                className="max-h-8 max-w-full object-contain"
                onError={(event) => {
                  event.currentTarget.style.display = 'none';
                  const parent = event.currentTarget.parentElement;
                  if (parent && !parent.querySelector('[data-vendor-fallback]')) {
                    const span = document.createElement('span');
                    span.dataset.vendorFallback = '1';
                    span.className = 'text-caption text-text-secondary text-center';
                    span.textContent = vendor.Name;
                    parent.appendChild(span);
                  }
                }}
              />
            </Link>
          </div>
        ))}
      </HorizontalScrollRow>
    </section>
  );
}
